import { render } from "./WorldCitySearchWidget.vue?vue&type=template&id=ddeaafa2&scoped=true"
import script from "./WorldCitySearchWidget.vue?vue&type=script&lang=js"
export * from "./WorldCitySearchWidget.vue?vue&type=script&lang=js"

import "./WorldCitySearchWidget.vue?vue&type=style&index=0&id=ddeaafa2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2623155984/src/jamakkol-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddeaafa2"]])

export default __exports__